import Vue from 'vue'
import Router from 'vue-router'
import region from '../utils/region.js'
import routeHelper from '../utils/routeHelper.js'

import {ORENB, ORLOV, HMAO, KRASN, KALUG, KAREL, SAAS, TATAR, MARIEL, KURGAN, YANAO, BURYATIA, CHUVA, KURSK, CRIMEA, PSCOV} from '../config/region.js'

import RoutesOrenb from './region.orenb.js'
import RoutesDefault from './region.default.js'
import RoutesOrlov from './region.orlov.js'
import RoutesHmao from './region.hmao.js'
import RoutesKrasn from './region.krasn.js'
import RoutesKalug from './region.kalug.js'
import RoutesKarel from './region.karel.js'
import RoutesSaas from './region.saas.js'
import RoutesTatar from './region.tatar.js'
import RoutesMariel from './region.mariel.js'
import RoutesKurgan from './region.kurgan.js'
import RoutesYanao from './region.yanao.js'
import RouterBuryatia from './region.buryatia.js'
import RouterChuva from './region.chuva'
import RouterKursk from './region.kursk'
import RouterCrimea from './region.crimea'
import RouterPscov from './region.pscov'

Vue.use(Router)

const ROUTES = {
  default: RoutesDefault,
  [ORENB]: RoutesOrenb,
  [ORLOV]: RoutesOrlov,
  [HMAO]: RoutesHmao,
  [KRASN]: RoutesKrasn,
  [KALUG]: RoutesKalug,
  [KAREL]: RoutesKarel,
  [SAAS]: RoutesSaas,
  [TATAR]: RoutesTatar,
  [MARIEL]: RoutesMariel,
  [KURGAN]: RoutesKurgan,
  [YANAO]: RoutesYanao,
  [BURYATIA]: RouterBuryatia,
  [CHUVA]: RouterChuva,
  [KURSK]: RouterKursk,
  [CRIMEA]: RouterCrimea,
  [PSCOV]: RouterPscov
}

const ROUTE = region.getRegionConfig(ROUTES)

// show progress bar before async component loading
function beforeEnter (to, from, next) {
  if (Vue.prototype && Vue.prototype.$bar) {
    Vue.prototype.$bar.startOrContinue()
  }
  next()
}

routeHelper.addBeforeEnterRecursive(ROUTE, beforeEnter)

const RouterInstance = new Router(ROUTE)

RouterInstance.replace = function (location, onComplete, onAbort) {
  // notify hooks about replace call
  if (location && location.hasOwnProperty('isReplace')) {
    this.isReplace = location.isReplace
  } else {
    this.isReplace = true
  }
  // in hooks use this.$router.isReplace
  Router.prototype.replace.call(this, location, onComplete, onAbort)
  // after call unset flag
  this.isReplace = false
}

export default RouterInstance

// dynamic import if needed https://github.com/tc39/proposal-dynamic-import
/* import region from '../utils/region.js'
let currentRegion = region.currentRegion()

export default function createRouterAsync (VueRouter) {
  return new Promise((resolve, reject) => {
    import(`./region.${currentRegion}.js`).then(route => {
    console.log('routes loaded, used=' + currentRegion)
    resolve(new VueRouter(route.default))
  }).catch(e => {
    reject(e)
  })
})
}

in main.js
createRouterAsync(VueRoute).then(router => {
 router.beforeResovle(...)
 ...
 new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App)
})
})
*/
